import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostHealthScheduledAppointments,
	PostHealthScheduledAppointmentsModel,
	PostHealthScheduledAppointmentsParams,
} from 'domain/usecases';

export class RemotePostHealthScheduledAppointments implements PostHealthScheduledAppointments {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostHealthScheduledAppointmentsModel>,
	) {}

	async post(
		params: PostHealthScheduledAppointmentsParams,
	): Promise<PostHealthScheduledAppointmentsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			case HttpStatusCode.unprocessable: {
				const notifications = httpResponse.data.notifications[0];
				throw new APIError(
					httpResponse.status,
					notifications.message,
					notifications.errorNumber,
				);
			}
			default: {
				throw new APIError(httpResponse.status, httpResponse.data);
			}
		}
	}
}
